/**
 * AutoCount - Add Vehicle Page
 */

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Autocomplete from "@mui/material/Autocomplete";

import { useNavigate } from "react-router-dom";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

const manufacturers = ["Toyota", "Honda", "Ford", "Chevrolet", "BMW", "Mercedes-Benz", "Volkswagen"];
const bodyTypes = ["Sedan", "Coupe", "Hatchback", "SUV", "Truck", "Van", "Convertible"];
const fuelTypes = ["Gasoline", "Diesel", "Hybrid", "Electric", "Plug-in Hybrid"];
const transmissions = ["Automatic", "Manual", "CVT", "Dual Clutch"];
const driveTypes = ["FWD", "RWD", "AWD", "4WD"];

function VehiclesAdd(): JSX.Element {
  const navigate = useNavigate();
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Add New Vehicle
                </MDTypography>
              </MDBox>
              <MDBox p={3}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={4}>
                    <Autocomplete
                      options={manufacturers}
                      renderInput={(params) => <MDInput {...params} label="Manufacturer *" />}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <MDInput label="Make *" fullWidth />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <MDInput label="Model *" fullWidth />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <MDInput label="Year *" type="number" fullWidth />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <MDInput label="Trim" fullWidth />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <MDInput label="Engine Code" fullWidth />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <MDInput label="Engine Size" fullWidth placeholder="e.g., 2.5L I4" />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <Autocomplete
                      options={bodyTypes}
                      renderInput={(params) => <MDInput {...params} label="Body Type" />}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <Autocomplete
                      options={fuelTypes}
                      renderInput={(params) => <MDInput {...params} label="Fuel Type" />}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <Autocomplete
                      options={transmissions}
                      renderInput={(params) => <MDInput {...params} label="Transmission" />}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <Autocomplete
                      options={driveTypes}
                      renderInput={(params) => <MDInput {...params} label="Drive Type" />}
                    />
                  </Grid>
                </Grid>
                <MDBox mt={4} display="flex" justifyContent="flex-end" gap={2}>
                  <MDButton variant="outlined" color="secondary" onClick={() => navigate("/vehicles")}>Cancel</MDButton>
                  <MDButton variant="gradient" color="info" onClick={() => navigate("/vehicles")}>Save Vehicle</MDButton>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default VehiclesAdd;
